import Colapsetower from '../colapsetower/colapsetower.vue'
export default {
  components: {Colapsetower},
  name: 'Towerscourtacording',
  props: ['dtgr', 'enumStatus', 'dataUnity', 'dataGroup', 'dataType', 'dataEnterprise'],
  data () {
    return {
      changeAngel: false
    }
  },
  methods: {
    getCountApr (group, locality) {
      if (this.dataUnity.length > 0) {
        return this.dataUnity.filter((Element) => Element.grupo === group && Element.localidade === locality).length
      }
    },
    getByLocalityAndGroup (group, locality) {
      if (this.dataUnity.length > 0) {
        return this.dataUnity.filter((Element) => Element.grupo === group && Element.localidade === locality)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/views/private/realestate/enterprise/components/towerscourtacording/towerscourtacording.js